// 构建版本标记的唯一读取处。值来自 vite.config.ts 的 buildVersionPlugin（define 注入的
// 编译期常量），与 `dist/version.json` 里的 buildId 是同一个字符串——发布脚本复检时比对的
// 就是它，界面上显示的也是它。
//
// 为什么要 `typeof` 守卫而不是直接引用：单元测试跑的是 vitest.config.ts，那份配置里没有
// 注入这个常量，直接引用会让任何渲染到本模块的用例抛 ReferenceError（测试环境不是构建环境）。
// 退化成 'dev' 是刻意的——它一眼就能看出「这不是构建产物」。
//
// `__APP_BUILD_ID__` 的全局声明在 `src/vite-env.d.ts`，只在那里声明一次。
export const BUILD_ID: string = typeof __APP_BUILD_ID__ === 'undefined' ? 'dev' : __APP_BUILD_ID__
